import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Subscribable } from 'rxjs';
import { PtgInterface } from '../model/ptgs/ptg-interface';

import { Injectable } from '@angular/core';
import { UserService } from '../services/user-service/userservice';
import { PtgService } from '../services/dataServices/ptg-service/ptgService';
import { SidemenuServiceService } from '../services/componentServices/sidemenu-service/sidemenu-service.service';
@Injectable()
export class PtgVersionResolver implements Resolve<any> {
    constructor(
        private ptgService: PtgService,
        private userservice: UserService
    ) {}

    resolve(route: ActivatedRouteSnapshot) {
        let ptgVersion = parseInt(route.paramMap.get('versionId'));
        if (ptgVersion) {
            this.ptgService.setActiveVersion(ptgVersion);
        }
        return true; // Angular 18 requires resolvers to return a value
    }
}
